<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
    <!-- Total Samples -->
    <div class="bg-black border border-gray-300 dark:border-gray-700 rounded-sm p-4">
        <div class="flex items-center gap-4">
            <i class="pi pi-database text-blue-500 dark:text-blue-300" style="font-size: 1.7rem"></i>
            <div>
                <p class="text-sm font-semibold text-gray-500 dark:text-gray-400">Total Samples</p>
                <p class="text-2xl font-bold text-gray-800 dark:text-white">{{ homeStats.totalSamples || 0 }}</p>
            </div>
        </div>
    </div>

    <!-- Total Vehicle Models (hidden for producers) -->
    @if (canSeeVehicleModels()) {
    <div class="bg-black border border-gray-300 dark:border-gray-700 rounded-sm p-4">
        <div class="flex items-center gap-4">
            <i class="pi pi-car text-green-500 dark:text-green-300" style="font-size: 1.7rem"></i>
            <div>
                <p class="text-sm font-semibold text-gray-500 dark:text-gray-400">Total Vehicle Models</p>
                <p class="text-2xl font-bold text-gray-800 dark:text-white">{{ homeStats.totalVehicleModels || 0 }}</p>
            </div>
        </div>
    </div>
    }

    <!-- Total Process Changes -->
    <div class="bg-black border border-gray-300 dark:border-gray-700 rounded-sm p-4">
        <div class="flex items-center gap-4">
            <i class="pi pi-refresh text-yellow-500 dark:text-yellow-300" style="font-size: 1.7rem"></i>
            <div>
                <p class="text-sm font-semibold text-gray-500 dark:text-gray-400">Total Sample Processes</p>
                <p class="text-2xl font-bold text-gray-800 dark:text-white">{{ homeStats.totalProcessChanges || 0 }}</p>
            </div>
        </div>
    </div>

    <!-- Total Approved Samples -->
    <div class="bg-black border border-gray-300 dark:border-gray-700 rounded-sm p-4">
        <div class="flex items-center gap-4">
            <i class="pi pi-check-circle text-purple-500 dark:text-purple-300" style="font-size: 1.7rem"></i>
            <div>
                <p class="text-sm font-semibold text-gray-500 dark:text-gray-400">Total Approved Samples</p>
                <p class="text-2xl font-bold text-gray-800 dark:text-white">{{ homeStats.totalApprovedSamples || 0 }}</p>
            </div>
        </div>
    </div>
</div>
<div class="mb-10">
    <h3 class="text-2xl font-semibold text-gray-800 dark:text-white mb-2">Recent Process Logs</h3>
    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="processLogs"
                [paginator]="true"
                [rows]="rows"
                [totalRecords]="totalRecords"
                [first]="currentPage * rows"
                [lazy]="true"
                [loading]="loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Sample</th>
                    <th>Comment</th>
                    <th>From State</th>
                    <th>To State</th>
                    <th>Timestamp</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-processLog>
                <tr>
                    <td>{{ processLog.sample?.printedName }}</td>
                    <td>{{ processLog.comment }}</td>
                    <td>
                        <p-tag
                                [value]="processLog.fromState | enumLabel"
                                [severity]="processLog.fromState | sampleStateSeverity"
                        ></p-tag>
                    </td>
                    <td>
                        <p-tag
                                [value]="processLog.toState | enumLabel"
                                [severity]="processLog.toState | sampleStateSeverity"
                        ></p-tag>
                    </td>
                    <td>{{ processLog.timestamp | formatDateTime }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button icon="pi pi-eye" text routerLink="/samples/sample/{{processLog.sample?.id}}"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<div class="mb-10">
    <h3 class="text-2xl font-semibold text-gray-800 dark:text-white mb-2">Stats for the last 100 days</h3>
    <div class=" grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div class="border border-gray-300 dark:border-gray-700 rounded-sm p-4">
            <app-sample-process-log-chart></app-sample-process-log-chart>
        </div>
        <div class="border border-gray-300 dark:border-gray-700 rounded-sm p-4">
            <app-cumulative-sample-chart></app-cumulative-sample-chart>
        </div>
    </div>
</div>

